import { render, staticRenderFns } from "./FiscalIdentificationData.vue?vue&type=template&id=258c701b&scoped=true&"
import script from "./FiscalIdentificationData.vue?vue&type=script&lang=js&"
export * from "./FiscalIdentificationData.vue?vue&type=script&lang=js&"
import style0 from "./FiscalIdentificationData.vue?vue&type=style&index=0&id=258c701b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258c701b",
  null
  
)

export default component.exports